<template>
  <div>
    <page-title icon="fas fa-table" main="Cadastro" sub="Regiões" :help="true" titleHelp="Ajuda - Regiões"
      content="Responsável por listar as regiões e seus respectivos vendedores. Para encontrar um vendedor insira o endereço e aperte 'enter'." />

    <card>
      <div slot="header" class="row align-items-center">
        <div class="col">
          <h5 class="h3 mb-0">Filtros</h5>
          <h6 class="text-uppercase text-muted ls-1 mb-1">
            Para cadastrar uma nova região: <strong>CADASTRO > SETORES > CADASTRO</strong>
          </h6>
        </div>
      </div>

      <region-filter-form :filters.sync="filter" ref="filterForm" />

      <div slot="footer" class="row justify-content-end" style="gap: 8px;">
        <base-button color="green" type="neutral" class="pr-2" @click="clearFilters()">
          Limpar Filtros
        </base-button>
        <base-button type="primary" @click="setData()">
          <i class="fas fa-filter"></i> Filtrar
        </base-button>
      </div>
    </card>

    <card>
      <div class="row">
        <div class="col-12 col-md-4 px-0 mb-3 mb-sm-0"
          style="border: 1px solid #e9ecef; border-radius: 0.375rem; overflow-x: hidden;">
          <region-list :regions="regions" @edit-region="openRegionModal($event.id)" @remove-region="onRemoveRegion"
            @highlight-region="highlightRegion" />
        </div>
        <div class="col-12 col-md-8 px-0 pl-md-3">
          <region-map :markers.sync="markers" height="50vh" :zoom="6" :marker-draggable="canUpdateRegion"
            @marker-clicked="onMarkerClicked" @update:marker="confirmMarkerUpdate" readOnly
            :highlight-region-id="highlightedRegionId">
            <template v-slot:marker-tooltip="{ marker }">
              <l-tooltip style="border-radius: 20px">
                <div style="font-family: Open Sans, sans-serif; color: #525f7f;">
                  <span v-if="marker.tooltip" style="font-size: 1rem; font-weight: 400; ">
                    {{ marker.tooltip }}
                  </span>
                  <div v-if="canUpdateRegion">
                    <br>
                    <i class="fas fa-mouse-pointer"></i>
                    <span> Clique para editar</span>
                    <br>
                    <i class="fas fa-arrows-alt"></i>
                    <span> Arraste para mudar a localização</span>
                  </div>
                </div>
              </l-tooltip>
            </template>
          </region-map>
        </div>
      </div>
    </card>

    <card>
      <div class="row">
        <div class="col-12 col-md-4 px-0 mb-3 mb-sm-0"
          style="border: 1px solid #e9ecef; border-radius: 0.375rem; overflow-x: hidden;">
          <region-list
            :regions="regions"
            @edit-region="openRegionModal($event.id)" 
            @remove-region="onRemoveRegion"
            @highlight-region="highlightRegion" 
          />
        </div>
        <div class="col-12 col-md-8 px-0 pl-md-3">
          <region-map 
            :markers="markers"
            :marker-draggable="canUpdateRegion"
            readOnly
            height="50vh" 
            :zoom="6"
            @marker-clicked="onMarkerClicked" @update:marker="confirmMarkerUpdate"
            :highlight-region-id="highlightedRegionId">
            <template v-slot:marker-tooltip="{ marker }">
              <l-tooltip style="border-radius: 20px">
                <div style="font-family: Open Sans, sans-serif; color: #525f7f;">
                  <span v-if="marker.tooltip" style="font-size: 1rem; font-weight: 400; ">
                    {{ marker.tooltip }}
                  </span>

                  <div v-if="canUpdateRegion">
                    <br>
                    <i class="fas fa-mouse-pointer"></i>
                    <span> Clique para editar</span>
                    <br>
                    <i class="fas fa-arrows-alt"></i>
                    <span> Arraste para mudar a localização</span>
                  </div>
                </div>
              </l-tooltip>
            </template>
          </region-map>
        </div>
      </div>
    </card>

    <region-modal 
      :show.sync="modals.editRegion" 
      :region="selectedRegion" 
      @close="modals.editRegion = false"
      @save="onRegionSave" 
      :is-saving="isSavingRegion" />
  </div>
</template>
<script>
import { Table, TableColumn, Tooltip } from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import RegionMap from '@/views/Sectors/regionMap';
import { LTooltip } from 'vue2-leaflet';
import swal from 'sweetalert2';
import RegionModal from "../../components/Regions/RegionModal.vue";
import RegionList from "../../components/Regions/RegionList.vue";
import RegionFilterForm from "../../components/Regions/RegionFilterForm.vue";

export default {
  name: "app",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
    PageTitle,
    Multiselect,
    RegionMap,
    RegionModal,
    RegionList,
    RegionFilterForm,
    LTooltip,
  },
  data() {
    return {
      modals: {
        modal0: false,
        editRegion: false,
      },
      isSavingRegion: false,
      selectedRegion: null,
      highlightedRegionId: null,
      highlightTimeout: null,
      filterSelects: {},
      filter: {},
      errors: [],
      regions: [],
      markers: [],
      // flag de verificação se foi pesquisado algo
      filtered: false,
      paginated_data: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.setData();
    });
  },
  methods: {
    rowClicked(row) {
      this.$refs.regions.toggleRowExpansion(row);
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    resetMarkersCoordinates() {
      this.markers = this.markers.map(function (el) {
        el.coordinates = [el.lat, el.long];
        return el;
      });
    },
    clearFilters() {
      this.filter = {
        branch: null,
        manager: null,
        salesman: null,
        name: "",
        status: { name: "ativo", value: 'true' },
        anosafra: this.$store.state.currentAnosafra,
      };

      this.setData();
    },
    setData(q, page) {
      if (typeof page === "undefined") page = null;
      if (typeof q === "undefined" || this.emptyFilter) q = null;

      const params = {
        q: {
          branch_id: this.filter.branch && this.filter.branch.id,
          manager_id: this.filter.manager && this.filter.manager.id,
          salesman_id: this.filter.salesman && this.filter.salesman.id,
          name: this.filter.name,
          active: this.filter.status && this.filter.status.value || 'true',
        },
      };

      if (this.filter.anosafra && this.filter.anosafra.id) {
        params.q.anosafra_id = this.filter.anosafra.id;
      } else {
        params.q.anosafra_id = this.$store.state.currentAnosafra.id;
      }

      this.$http.secured
        .get("/api/v1/regions", { params: params })
        .then(response => {
          // setando dados de paginação e a collection produtos
          this.regions = response.data;
          var markers = this.regions.map(function (e) {
            return [e.name, e.region_position];
          })
          markers = markers.filter(e => e[1]);
          markers = markers.map(function (el) {
            let o = Object.assign({}, el[1]);
            o.coordinates = [el[1].lat, el[1].long];
            o.tooltip = el[0]
            return o;
          })
          this.markers = markers;
        })
        .catch(error => this.setError(error, "Something went wrong"));
    },
    openRegionModal(regionId) {
       if (!this.canUpdateRegion) {
        this.$toasted.global.defaultWarnig({
          msg: 'Usuário não possui permissão para editar!',
        });
        return;
      }

      const region = this.regions.find(region => region.id === regionId);
      if (!region.region_position) {
        region.region_position = {
          radius: 4500,
        }
      }

      region.region_position = {
        ...region.region_position,
        coordinates: [
          parseFloat(region.region_position && region.region_position.lat || 0),
          parseFloat(region.region_position && region.region_position.long || 0),
        ],
      };

      this.selectedRegion = region;
      this.modals.editRegion = true;
      
    },
    onMarkerClicked(marker) {
      
      this.openRegionModal(marker.region_id);
    },
    highlightRegion(marker) {
      this.$nextTick(() => {
        this.highlightedRegionId = marker.id;
      });
      
      if (this.highlightTimeout) {
        clearTimeout(this.highlightTimeout);
      }

      this.highlightTimeout = setTimeout(() => {
        this.highlightedRegionId = null;
      }, 5000);
    },
    unhighlightRegion() {
      this.highlightedRegionId = null;
    },
    async updateMarker(marker) {
      
      return await this.$http.secured.put(`/api/v2/region_positions/${marker.id}`, {
        region_position: {
          lat: marker.coordinates[0],
          long: marker.coordinates[1],
        },
      });
    },
    async confirmMarkerUpdate(marker) {
      const response = await swal.fire({
        title: 'Deseja realmente alterar a localização da região?',
        text: 'Essa ação não poderá ser desfeita!',
        icon: 'warning',
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonText: 'Sim, alterar!',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        preConfirm: async () => {
          try {
            await this.updateMarker(marker)

            this.setData();

            this.$toasted.global.defaultSuccess({
              msg: 'Localização da região alterada com sucesso!',
            });

            return true;
          } catch (error) {
            swal.showValidationMessage('Não foi possível alterar a localização da região. Tente novamente mais tarde.');
            return false;
          }
        },
      });

      if (!response.value) {
        this.resetMarkersCoordinates();
      }
    },
    async onRegionSave(updatedRegion) {
      this.isSavingRegion = true;

      const region = {
        ...this.selectedRegion,
        ...updatedRegion,
        region_position_attributes: {
          ...this.selectedRegion.region_position,
        },
      }
      try {
        const response = await this.$http.secured.put(`/api/v1/regions/${this.selectedRegion.id}`, {
          region
        });

        this.setData();
        this.$toasted.global.defaultSuccess({
          msg: 'Região atualizada com sucesso!',
        });

        this.modals.editRegion = false;
      } catch (error) {
        console.error('[Regions/Index.vue] onRegionSave', error);
      }

      this.isSavingRegion = false;
    },
    async onRemoveRegion(region) {
      try {
        await this.$http.secured.delete(`/api/v1/regions/${region.id}`);

        this.setData();

        this.$toasted.global.defaultSuccess({
          msg: 'Região excluída com sucesso!',
        });
      } catch (error) {
        console.error('[Regions/Index.vue] onRemoveRegion', error);
      }
    },
  },
  computed: {
    emptyFilter: function () {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    },
    canUpdateRegion() {
      return this.$can('update', 'region_position');
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
